@import "@/styles/variables";

.input {
	width: 99%;
	padding: 7px;
	padding-bottom: 8px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 13px;
	outline: none;

	&:focus {
		border-color: #007bff;
		box-shadow: 0 0 0 1px #2684ff;
	}
}

.textSpan {
	cursor: pointer;
	display: inline-block;
	padding: 4px 8px;
	border-radius: 4px;
	transition: background-color 0.2s;
}

.editable_button {
	margin-right: 5px;
	display: flex;

	.button_cancel,
	.button_confirm {
		width: 50%;
		border: none;
		background-color: $primary-color;
		color: white;
		margin: 0.2rem 2px;
		border-radius: 5px;
		cursor: pointer;
		font-size: 13px;
		padding: 3px;
	}

	.button_cancel {
		background-color: $danger-color;
		color: white;

		&:hover {
			background-color: $danger-hover;
		}
	}

	.button_confirm {
		background-color: $primary-color;
		color: white;

		&:hover {
			background-color: $primary-hover;
		}
	}
}
